import { Component, ElementRef, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, FormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Constants } from '@core/globals/constants';
import { PhrasePipe } from '@shared/pipes/phrase.pipe';
import { Subject } from 'rxjs';
import { AsSnackBar } from '@shared/modules/as-snack-bar/as-snack-bar.service';

@Component({
  selector: 'app-shto-fjalen-shpejt-dialog',
  templateUrl: './shto-fjalen-shpejt-dialog.component.html',
  styleUrls: ['./shto-fjalen-shpejt-dialog.component.scss']
})
export class ShtoFjalenShpejtDialogComponent implements OnInit, OnDestroy {

  shtoFjalenFormGroup = new UntypedFormGroup({
    fjalet: new UntypedFormArray([
    ])
  });

  constructor(
    host: ElementRef,
    renderer: Renderer2,
    private fb: UntypedFormBuilder,
    private dialogRef: MatDialogRef<ShtoFjalenShpejtDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private asSnackBar: AsSnackBar,
    private phrasePipe: PhrasePipe
  ) { }


  Nyjet = Constants.Nyja;
  Homonimet = Constants.Homonimet;

  private _onDestroy$: Subject<void> = new Subject<void>();

  ngOnInit(): void { }


  addControl() {
    // let group = new FormGroup({
    //   fjala: new FormControl<string | null>('', [Validators.required]),
    //   homonimi: new FormControl<number | null>(0),
    //   nyjaId: new FormControl<number | null>(null),
    //   fjaloriId: new FormControl<number>(this.data.fjaloriId),
    //   pjesaLigjeratesId: new FormControl<number | null>(null),
    //   emriBaza: new FormGroup({
    //     id: new FormControl<number | null>(null),
    //     gjiniaId: new FormControl<number | null>(null),
    //     numriId: new FormControl<number | null>(null),
    //     llojiId: new FormControl<number | null>(null),
    //   }),
    //   mbiemriBaza: new FormGroup({
    //     id: new FormControl<number | null>(null),
    //     gjiniaId: new FormControl<number | null>(null),
    //     llojiId: new FormControl<number | null>(null),
    //   }),
    //   foljaBaza: new FormGroup({
    //     id: new FormControl<number | null>(null),
    //     kalimtaresiaId: new FormControl<number | null>(null),
    //   }),
    //   epapercaktuarBaza: new FormGroup({
    //     id: new FormControl<number | null>(null),
    //     llojiId: new FormControl<number | null>(null),
    //   }),
    // });

    // this.shtoFjalenFormGroup.controls.fjalet.controls.push(group);
    // this.shtoFjalenFormGroup.markAsDirty();
  }

  removeControl(index: number) {
    // this.shtoFjalenFormGroup.controls.fjalet.removeAt(index);
  }

  onSubmit() {
    // if(this.shtoFjalenFormGroup.valid) {
    //   this.shtoFjaleShpejtService.post(this.getDTO()).subscribe(() => {
    //     if(this.shtoFjalenFormGroup.controls.fjalet.length > 1)
    //       this.asSnackBar.openSnackBar(this.phrasePipe.transform('words_saved_successfully'), AsSnackBarStatus.Success, 5000);
    //     else
    //       this.asSnackBar.openSnackBar(this.phrasePipe.transform('word_saved_successfully'), AsSnackBarStatus.Success, 5000);
    //   });
    // }
  }

  private getDTO() {
    // const value = this.shtoFjalenFormGroup.getRawValue();

    // let dtos: ShtoFjalenShpejteForCreationDTO[] = [];

    // value.fjalet.forEach((f) => {
    //   dtos.push({
    //     fjala: f.fjala!,
    //     fjaloriId: f.fjaloriId!,
    //     homonimi: f.homonimi ?? undefined,
    //     nyjaId: f.nyjaId ?? undefined,
    //     pjesaLigjeratesId: f.pjesaLigjeratesId ?? undefined
    //   });
    // })

    // return dtos;
  }

  close() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this._onDestroy$.next();
    this._onDestroy$.complete();
  }
}
